import React from "react";
import AdminSignInLayer from "../../components/admin/AdminSignInLayer";

const AdminSignInPage = () => <AdminSignInLayer />;

export default AdminSignInPage;
